/* eslint-disable react-hooks/exhaustive-deps */
'use client';

import { useEffect } from 'react';
import { getStore } from '~/mobx/AppStore';

type Props = {
    selectedElectionId: string;
    selectedRegionId: string;
    selectedSlagId: string;
    slagPage: string;
};

const Client = (props: Readonly<Props>) => {
    const { ballotStore } = getStore();

    useEffect(() => {
        ballotStore.setSelectedElectionId(props.selectedElectionId);
        ballotStore.setSelectedRegionId(props.selectedRegionId);
        ballotStore.setSelectedSlagId(props.selectedSlagId);
        ballotStore.setSlagPage(props.slagPage);
    }, []);

    return null;
};

export default Client;
